import { useQuery } from "@apollo/client"
import { DataTable } from "~/ui/data-table"
import { columns } from "./columns"
import { gql } from "~/__generated__"
import { Button } from "~/ui/button"
import { Link } from "react-router-dom"
import { TablePageLayout } from "~/layouts/table-page-layout"

const PLANS_QUERY = gql(/* GraphQL */ `
  query Plans {
    plans {
      edges {
        node {
          id
          title
          description
          datetime
          minPeople
          maxPeople
          location {
            id
            name
          }
          createdAt
        }
      }
    }
  }
`)

export function PlansScreen() {
  const { data, loading } = useQuery(PLANS_QUERY)

  if (loading) return <div>Loading...</div>

  const plans = data?.plans?.edges?.map((edge) => edge?.node) ?? []

  return (
    <TablePageLayout>
      <div className="flex items-center justify-between">
        <h1 className="text-2xl">Plans</h1>
        <Link to="/plans/new">
          <Button variant="outline">New Plan</Button>
        </Link>
      </div>
      <hr className="my-4 border-0 border-b" />
      <DataTable columns={columns} data={plans} />
    </TablePageLayout>
  )
}
